/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface SignupDto {
	name?: string;
	family?: string;
	/**
	 * @example
	 * 	2018 - 11 - 21;
	 *
	 * @format date
	 */
	birthday?: string;
	email: string;
	password: string;
	/** @format binary */
	avatar?: File;
	verificationCode: string;
}

export interface RandomReminderSettings {
	enabled?: boolean;
}

export interface EndOfDayReminderSettings {
	enabled?: boolean;
	/**
	 * @example
	 * 	09:30
	 */
	time?: string;
}

export interface UserSettings {
	emailNotification?: boolean;
	pushNotification?: boolean;
	localNotification?: boolean;
	notificationsEnabled?: boolean;
	reminderRandom?: RandomReminderSettings;
	reminderEOD?: EndOfDayReminderSettings;
	model?: string;
}

export interface User {
	id: string;
	/** @format date-time */
	createdAt: string;
	/** @format date-time */
	updatedAt: string;
	email: string;
	emailVerified: boolean;
	name?: string;
	family?: string;
	avatarURL?: string;
	friendId: string;
	/**
	 * @example
	 * 	2018 - 11 - 21;
	 *
	 * @format date
	 */
	birthday?: string;
	settings?: UserSettings;
	authSource: "MANUAL" | "GOOGLE" | "APPLE";
}

export interface AuthResponse {
	accessToken: string;
	refreshToken: string;
	user: User;
}

export interface SignInDto {
	email: string;
	password: string;
}

export interface EmailVerificationCodeDto {
	email: string;
}

export interface VerifySignupVerificationCodeDto {
	email: string;
	verificationCode: string;
}

export interface VerifyVerificationCodeDto {
	email: string;
	verificationCode: string;
	password?: string;
}

export interface HasAccess {
	hasAccess: boolean;
}

export interface ProgressionStatus {
	reflection: "NOT_STARTED" | "COMPLETED_OPTIONAL" | "COMPLETED_ALL";
	friend_check: "NOT_STARTED" | "STARTED" | "CLOSED" | "ANALYSED" | "SUMMARIZED";
	core_values: "NOT_STARTED" | "SUMMARIZED";
	chosen_core_values: "NOT_STARTED" | "COMPLETED";
	core_value_accuracy: number;
}

export interface UpdateUserDto {
	name?: string;
	family?: string;
	/**
	 * @example
	 * 	2018 - 11 - 21;
	 *
	 * @format date
	 */
	birthday?: string;
	/** @format binary */
	avatar?: File;
}

export interface UpdateUserSettingsDto {
	emailNotification?: boolean;
	pushNotification?: boolean;
	localNotification?: boolean;
	notificationsEnabled?: boolean;
	reminderRandom?: RandomReminderSettings;
	reminderEOD?: EndOfDayReminderSettings;
	model?: string;
}

export interface SendMessageDto {
	title: string;
	body: string;
}

export interface AddDeviceDto {
	token: string;
	name: string;
}

export interface UserDevice {
	token: string;
	/** @format date-time */
	createdAt: string;
	name: string;
}

export interface UserDevicesDto {
	deviceIds: string[];
}

export interface CoreValuesAnalysis {
	id: string;
	name: string;
	score: number;
	reason: string;
	color: string;
	emoji: string;
}

export interface CoreValueItem {
	id: string;
	name: string;
	emoji: string;
	color: string;
}

export interface SelectedCoreValueDto {
	id: string;
	matchScore: number;
	reason: string;
	coreValue: CoreValueItem;
}

export interface SelectedCoreValueInputDto {
	name: string;
	matchScore: number;
	reason: string;
}

export interface RefineCoreValueDto {
	question: string;
	chosenCoreValueId: string;
}

export interface ChosenCoreValueDto {
	id: string;
	reason: string;
}

export interface Top5CoreValuesDto {
	values: ChosenCoreValueDto[];
}

export interface ChosenCoreValueItem {
	id: string;
	reason: string;
	score: number;
	description: string;
	customName: string;
	coreValue: CoreValueItem;
}

export interface RefineProposal {
	description: string;
	name: string;
	answered: boolean;
	accepted: boolean;
}

export interface MessageItem {
	id: string;
	/** @format date-time */
	createdAt: string;
	messageRole: string;
	content: string;
	refineProposal: RefineProposal;
}

export interface ChosenCoreValueItemDetail {
	id: string;
	reason: string;
	score: number;
	description: string;
	customName: string;
	coreValue: CoreValueItem;
	messages: MessageItem[];
}

export interface ReflectionMessage {
	id: string;
	role: "USER" | "ASSISTANT";
	content: string;
}

export interface ReflectionSummary {
	id: string;
	name: string;
	reflectionChat?: ReflectionChat;
	optional: boolean;
	initialQuestion: string;
	initialMessageContent?: string;
	initialMessageChoices?: string[];
	initialMessageMaxChoices?: number;
}

export interface ReflectionChat {
	id: string;
	messages: ReflectionMessage[];
	generatedCoreValues: CoreValueItem[];
	reflection?: ReflectionSummary;
	status: "NOT_STARTED" | "IN_PROGRESS" | "CHAT_COMPLETED" | "FINISHED" | "SKIPPED";
	userSummary?: string;
	initialMessageAnswer?: string;
	initialMessageChosen?: string[];
	/** @format date-time */
	createdAt: string;
	/** @format date-time */
	updatedAt: string;
}

export interface ChosenCoreValueSourcesDto {
	reflections: ReflectionChat[];
	friendchecks: CoreValuesAnalysis[];
}

export interface ShareCodeResponseDto {
	/**
	 * Generated share code for core values
	 *
	 * @example
	 * 	123456;
	 */
	code: string;
}

export interface ReflectionInitialResponseDto {
	content?: string;
	choices?: string[];
}

export interface ReflectionTextResponseDto {
	content: string;
}

export interface GenerateSelectedCoreValuesDto {
	create: SelectedCoreValueDto[];
	update: SelectedCoreValueDto[];
}

export interface PerfectDayMessageImageAttachment {
	content: string;
	status: "SUCCESS" | "ERROR";
}

export interface PerfectDayMessage {
	id: string;
	role: "USER" | "TOOL" | "ASSISTANT" | "PROPOSAL";
	content: string;
	attachment?: PerfectDayMessageImageAttachment;
}

export interface PerfectDayChat {
	id: string;
	messages: PerfectDayMessage[];
	status: "REFLECTION" | "IMAGE_GENERATION" | "COMPLETED";
	summary?: string;
}

export interface PerfectDayScene {
	id: string;
	name: string;
	imageUrl?: string;
	sortOrder: number;
	chat: PerfectDayChat;
	isFinalScene: boolean;
}

export interface CreatePerfectDayScene {
	/**
	 * @minLength 4
	 * @maxLength 75
	 */
	name?: string;
	/**
	 * @minLength 4
	 * @maxLength 255
	 */
	description?: string;
}

export interface PerfectdayTextResponseDto {
	content: string;
}

export interface SceneOrder {
	id: string;
	sortOrder: number;
}

export interface UpdatePerfectDaySceneOrder {
	/** Array of scene IDs and their sort orders */
	scenes: SceneOrder[];
}

export interface UpdatePerfectDayScene {
	id: string;
	/**
	 * @minLength 4
	 * @maxLength 75
	 */
	name: string;
}

export interface FriendCheckAnswerPair {
	answer: string | string[];
	followUpQuestion?: FriendCheckAnswerPair | null;
	question: string;
}

export interface FriendCheckSubmission {
	questions: FriendCheckAnswerPair[];
	id: string;
	name: string;
	relation: string;
	email?: string;
	/** @format date-time */
	createdAt?: string;
	seen?: boolean;
}

export interface FriendCheckQuestionTree {
	id: string;
	question: string;
	questionType: "MULTIPLE_CHOICE" | "NUMBER" | "TEXT" | "EMAIL" | "DATA";
	options: string[];
	version: number;
	followUpQuestion: FriendCheckQuestionTree | null;
}

export interface FriendCheck {
	name?: string;
	avatarURL?: string;
	questions?: FriendCheckQuestionTree[];
	friendCheckEnabled?: boolean;
	version: number;
	id: string;
}

export interface FriendcheckQuestionsDto {
	questionId: string;
	answer: string;
}

export interface SubmitFriendcheckDto {
	name: string;
	email?: string;
	relation: string;
	questions: FriendcheckQuestionsDto[];
}

export interface FriendCheckSubmissionResponse {
	submissionId: string;
	patchUntil: string;
	patchToken: string;
}

export interface PatchFriendCheckEmailDto {
	submissionId: string;
	email: string;
	patchToken: string;
}

export interface PatchFriendCheckEnabledDto {
	enabled: boolean;
}

export interface PatchFriendCheckSeenDto {
	friendCheckSubmissionId: string;
	seen: boolean;
}

export interface ModelDto {
	key: string;
	name: string;
}

export enum Role {
	COACH = "COACH",
	PARENT = "PARENT",
	COACHEE = "COACHEE",
	UNDEFINED = "UNDEFINED",
}

export enum AccountType {
	PILOT = "PILOT",
	FREE_TRIAL = "FREE_TRIAL",
	PAID = "PAID",
	INTERNAL = "INTERNAL",
	UNDEFINED = "UNDEFINED",
}

export interface SendInviteEmailDto {
	name: string;
	email: string;
	organizationName?: string;
	imageUrl: string;
	baseUrl: string;
	apiToken: string;
	/**
	 * User role in the organization
	 *
	 * @example
	 * 	COACHEE;
	 */
	role: Role;
	/**
	 * User account type
	 *
	 * @example
	 * 	PAID;
	 */
	accountType: AccountType;
}

export interface ShareManifestDto {
	email: string;
}

export interface MissionProposalDto {
	id: string;
	mission: string;
	answered: boolean;
	accepted: boolean;
}

export interface PersonalMissionMessageDto {
	id: string;
	createdAt: string;
	messageRole: "USER" | "TOOL" | "ASSISTANT" | "PROPOSAL";
	content: string;
	missionProposal?: MissionProposalDto;
}

export interface PersonalMissionResponseDto {
	personalMission: string;
	messages: PersonalMissionMessageDto[];
}

export interface RefinePersonalMissionDto {
	message: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
	/** Set parameter to `true` for call `securityWorker` for this request */
	secure?: boolean;
	/** Request path */
	path: string;
	/** Content type of request body */
	type?: ContentType;
	/** Query params */
	query?: QueryParamsType;
	/** Format of response (i.e. response.json() -> format: "json") */
	format?: ResponseFormat | null;
	/** Request body */
	body?: unknown;
	/** Base url */
	baseUrl?: string;
	/** Request cancellation token */
	cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
	baseUrl?: string;
	baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
	securityWorker?: (
		securityData: SecurityDataType | null,
	) => Promise<RequestParams | void> | RequestParams | void;
	customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
	data: D;
	error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
	Json = "application/json",
	FormData = "multipart/form-data",
	UrlEncoded = "application/x-www-form-urlencoded",
	Text = "text/plain",
	Stream = "text/event-stream",
}

export class HttpClient<SecurityDataType = unknown> {
	public baseUrl: string = "";
	private securityData: SecurityDataType | null = null;
	private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
	private abortControllers = new Map<CancelToken, AbortController>();
	private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

	private baseApiParams: RequestParams = {
		credentials: "same-origin",
		headers: {},
		redirect: "follow",
		referrerPolicy: "no-referrer",
	};

	constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
		Object.assign(this, apiConfig);
	}

	public setSecurityData = (data: SecurityDataType | null) => {
		this.securityData = data;
	};

	protected encodeQueryParam(key: string, value: any) {
		const encodedKey = encodeURIComponent(key);
		return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
	}

	protected addQueryParam(query: QueryParamsType, key: string) {
		return this.encodeQueryParam(key, query[key]);
	}

	protected addArrayQueryParam(query: QueryParamsType, key: string) {
		const value = query[key];
		return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
	}

	protected toQueryString(rawQuery?: QueryParamsType): string {
		const query = rawQuery || {};
		const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
		return keys
			.map((key) =>
				Array.isArray(query[key])
					? this.addArrayQueryParam(query, key)
					: this.addQueryParam(query, key),
			)
			.join("&");
	}

	protected addQueryParams(rawQuery?: QueryParamsType): string {
		const queryString = this.toQueryString(rawQuery);
		return queryString ? `?${queryString}` : "";
	}

	private contentFormatters: Record<ContentType, (input: any) => any> = {
		[ContentType.Json]: (input: any) =>
			input !== null && (typeof input === "object" || typeof input === "string")
				? JSON.stringify(input)
				: input,
		[ContentType.Text]: (input: any) =>
			input !== null && typeof input !== "string" ? JSON.stringify(input) : input,
		[ContentType.FormData]: (input: any) =>
			Object.keys(input || {}).reduce((formData, key) => {
				const property = input[key];
				const propertyContent = property instanceof Array ? property : [property];

				for (const formItem of propertyContent) {
					const isFileType = formItem instanceof Blob || formItem instanceof File;
					formData.append(
						key,
						isFileType
							? formItem
							: typeof formItem === "object" && formItem !== null
								? JSON.stringify(formItem)
								: String(formItem),
					);
				}
				return formData;
			}, new FormData()),
		[ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
		[ContentType.Stream]: (input: any) => input,
	};

	protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
		return {
			...this.baseApiParams,
			...params1,
			...(params2 || {}),
			headers: {
				...(this.baseApiParams.headers || {}),
				...(params1.headers || {}),
				...((params2 && params2.headers) || {}),
			},
		};
	}

	protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
		if (this.abortControllers.has(cancelToken)) {
			const abortController = this.abortControllers.get(cancelToken);
			if (abortController) {
				return abortController.signal;
			}
			return void 0;
		}

		const abortController = new AbortController();
		this.abortControllers.set(cancelToken, abortController);
		return abortController.signal;
	};

	public abortRequest = (cancelToken: CancelToken) => {
		const abortController = this.abortControllers.get(cancelToken);

		if (abortController) {
			abortController.abort();
			this.abortControllers.delete(cancelToken);
		}
	};

	public request = async <T = any, E = any>({
		body,
		secure,
		path,
		type,
		query,
		format,
		baseUrl,
		cancelToken,
		...params
	}: FullRequestParams): Promise<HttpResponse<T, E>> => {
		const secureParams =
			((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
				this.securityWorker &&
				(await this.securityWorker(this.securityData))) ||
			{};
		const requestParams = this.mergeRequestParams(params, secureParams);
		const queryString = query && this.toQueryString(query);
		const payloadFormatter = this.contentFormatters[type || ContentType.Json];
		const responseFormat = format || requestParams.format;

		return this.customFetch(
			`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
			{
				...requestParams,
				headers: {
					...(requestParams.headers || {}),
					...(type && type !== ContentType.FormData && type !== ContentType.Stream
						? { "Content-Type": type }
						: {}),
					...(type && type === ContentType.Stream
						? { Accept: type, "Content-Type": ContentType.Json }
						: {}),
				},
				signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
				body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
			},
		).then(async (response) => {
			const r = response as HttpResponse<T, E>;
			r.data = null as unknown as T;
			r.error = null as unknown as E;

			const data = !responseFormat
				? r
				: await response[responseFormat]()
						.then((data) => {
							if (r.ok) {
								r.data = data;
							} else {
								r.error = data;
							}
							return r;
						})
						.catch((e: any) => {
							r.error = e;
							return r;
						});

			if (cancelToken) {
				this.abortControllers.delete(cancelToken);
			}

			if (!response.ok) throw data;
			return data;
		});
	};
}

/**
 * @version 0.4.8
 * @title core-imperfect
 * @contact
 *
 * Stijlbreuk Perfect Day Backend
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @name AppControllerGetInfo
	 * @request GET:/
	 */
	appControllerGetInfo = (params: RequestParams = {}) =>
		this.request<void, any>({
			path: `/`,
			method: "GET",
			...params,
		});

	auth = {
		/**
		 * No description
		 *
		 * @tags Authentication
		 * @name AuthControllerSignup
		 * @request POST:/auth/signup
		 */
		authControllerSignup: (data: SignupDto, params: RequestParams = {}) =>
			this.request<AuthResponse, any>({
				path: `/auth/signup`,
				method: "POST",
				body: data,
				type: ContentType.FormData,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Authentication
		 * @name AuthControllerSignin
		 * @request POST:/auth/signin
		 */
		authControllerSignin: (data: SignInDto, params: RequestParams = {}) =>
			this.request<AuthResponse, any>({
				path: `/auth/signin`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Authentication
		 * @name AuthControllerSendSignupVerificationCode
		 * @request POST:/auth/signup/verification/send
		 */
		authControllerSendSignupVerificationCode: (
			data: EmailVerificationCodeDto,
			params: RequestParams = {},
		) =>
			this.request<string, any>({
				path: `/auth/signup/verification/send`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Authentication
		 * @name AuthControllerVerifySignupVerificationCode
		 * @request POST:/auth/signup/verification/verify
		 */
		authControllerVerifySignupVerificationCode: (
			data: VerifySignupVerificationCodeDto,
			params: RequestParams = {},
		) =>
			this.request<boolean, any>({
				path: `/auth/signup/verification/verify`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Authentication
		 * @name AuthControllerSendPasswordResetVerificationCode
		 * @request POST:/auth/password-reset/send
		 */
		authControllerSendPasswordResetVerificationCode: (
			data: EmailVerificationCodeDto,
			params: RequestParams = {},
		) =>
			this.request<string, any>({
				path: `/auth/password-reset/send`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Authentication
		 * @name AuthControllerVerifyPasswordResetVerificationCode
		 * @request POST:/auth/password-reset/verify
		 */
		authControllerVerifyPasswordResetVerificationCode: (
			data: VerifySignupVerificationCodeDto,
			params: RequestParams = {},
		) =>
			this.request<boolean, any>({
				path: `/auth/password-reset/verify`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Authentication
		 * @name AuthControllerSendMagicLink
		 * @request POST:/auth/magic
		 */
		authControllerSendMagicLink: (data: EmailVerificationCodeDto, params: RequestParams = {}) =>
			this.request<string, any>({
				path: `/auth/magic`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Authentication
		 * @name AuthControllerVerifyMagicLink
		 * @request POST:/auth/magic/verify
		 */
		authControllerVerifyMagicLink: (
			data: VerifySignupVerificationCodeDto,
			params: RequestParams = {},
		) =>
			this.request<AuthResponse, any>({
				path: `/auth/magic/verify`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Authentication
		 * @name AuthControllerResetPassword
		 * @request POST:/auth/password-reset/reset
		 */
		authControllerResetPassword: (data: VerifyVerificationCodeDto, params: RequestParams = {}) =>
			this.request<AuthResponse, any>({
				path: `/auth/password-reset/reset`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Authentication
		 * @name AuthControllerRefresh
		 * @request POST:/auth/refresh
		 * @secure
		 */
		authControllerRefresh: (params: RequestParams = {}) =>
			this.request<string, any>({
				path: `/auth/refresh`,
				method: "POST",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Authentication
		 * @name AuthControllerGoogleAuth
		 * @request GET:/auth/google
		 */
		authControllerGoogleAuth: (
			query: {
				/**
				 * After login the callback url will call including "access-token" and "refresh-token" as
				 * query params.
				 */
				callbackUrl: string;
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/auth/google`,
				method: "GET",
				query: query,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Authentication
		 * @name AuthControllerGoogleAuthCallback
		 * @request GET:/auth/google/callback
		 */
		authControllerGoogleAuthCallback: (params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/auth/google/callback`,
				method: "GET",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Authentication
		 * @name AuthControllerAppleAuth
		 * @request GET:/auth/apple
		 */
		authControllerAppleAuth: (
			query: {
				/**
				 * After login the callback url will call including "access-token" and "refresh-token" as
				 * query params.
				 */
				callbackUrl: string;
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/auth/apple`,
				method: "GET",
				query: query,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Authentication
		 * @name AuthControllerAppleAuthCallback
		 * @request POST:/auth/apple/callback
		 */
		authControllerAppleAuthCallback: (params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/auth/apple/callback`,
				method: "POST",
				...params,
			}),
	};
	user = {
		/**
		 * No description
		 *
		 * @tags User
		 * @name UsersControllerMe
		 * @request GET:/user/me
		 * @secure
		 */
		usersControllerMe: (params: RequestParams = {}) =>
			this.request<User, any>({
				path: `/user/me`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags User
		 * @name UsersControllerUpdateMe
		 * @request PATCH:/user/me
		 * @secure
		 */
		usersControllerUpdateMe: (data: UpdateUserDto, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/user/me`,
				method: "PATCH",
				body: data,
				secure: true,
				type: ContentType.FormData,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags User
		 * @name UsersControllerGetMyAccess
		 * @request GET:/user/me/access
		 * @secure
		 */
		usersControllerGetMyAccess: (params: RequestParams = {}) =>
			this.request<HasAccess, any>({
				path: `/user/me/access`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags User
		 * @name UsersControllerGetMyProgressionStatus
		 * @request GET:/user/me/progression
		 * @secure
		 */
		usersControllerGetMyProgressionStatus: (params: RequestParams = {}) =>
			this.request<ProgressionStatus, any>({
				path: `/user/me/progression`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags User
		 * @name UsersControllerFindOne
		 * @request GET:/user/{id}
		 * @secure
		 */
		usersControllerFindOne: (id: string, params: RequestParams = {}) =>
			this.request<User, any>({
				path: `/user/${id}`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags User
		 * @name UsersControllerUpdate
		 * @request PATCH:/user/{id}
		 * @secure
		 */
		usersControllerUpdate: (id: string, data: UpdateUserDto, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/user/${id}`,
				method: "PATCH",
				body: data,
				secure: true,
				type: ContentType.FormData,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags User
		 * @name UsersControllerRemove
		 * @request DELETE:/user/{id}
		 * @secure
		 */
		usersControllerRemove: (id: string, params: RequestParams = {}) =>
			this.request<object, any>({
				path: `/user/${id}`,
				method: "DELETE",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags User
		 * @name UsersControllerUpdateSettings
		 * @request PATCH:/user/me/settings
		 * @secure
		 */
		usersControllerUpdateSettings: (data: UpdateUserSettingsDto, params: RequestParams = {}) =>
			this.request<UserSettings, any>({
				path: `/user/me/settings`,
				method: "PATCH",
				body: data,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags User
		 * @name UsersControllerGetMySettings
		 * @request GET:/user/me/settings
		 * @secure
		 */
		usersControllerGetMySettings: (params: RequestParams = {}) =>
			this.request<UserSettings, any>({
				path: `/user/me/settings`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags User
		 * @name UsersControllerGetAppData
		 * @request GET:/user/me/app-data
		 * @secure
		 */
		usersControllerGetAppData: (params: RequestParams = {}) =>
			this.request<Record<string, string | number | boolean>, any>({
				path: `/user/me/app-data`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags User
		 * @name UsersControllerUpdateAppData
		 * @request POST:/user/me/app-data
		 * @secure
		 */
		usersControllerUpdateAppData: (
			data: Record<string, string | number | boolean>,
			params: RequestParams = {},
		) =>
			this.request<Record<string, string | number | boolean>, any>({
				path: `/user/me/app-data`,
				method: "POST",
				body: data,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	notification = {
		/**
		 * No description
		 *
		 * @tags Notification
		 * @name NotificationControllerSendMessage
		 * @request POST:/notification/send
		 * @secure
		 */
		notificationControllerSendMessage: (data: SendMessageDto, params: RequestParams = {}) =>
			this.request<boolean, any>({
				path: `/notification/send`,
				method: "POST",
				body: data,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Notification
		 * @name NotificationControllerAddDevice
		 * @request POST:/notification/add-device
		 * @secure
		 */
		notificationControllerAddDevice: (data: AddDeviceDto, params: RequestParams = {}) =>
			this.request<UserDevice, any>({
				path: `/notification/add-device`,
				method: "POST",
				body: data,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Notification
		 * @name NotificationControllerGetDevices
		 * @request GET:/notification/devices
		 * @secure
		 */
		notificationControllerGetDevices: (params: RequestParams = {}) =>
			this.request<UserDevicesDto, any>({
				path: `/notification/devices`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),
	};
	corevalues = {
		/**
		 * No description
		 *
		 * @tags Core Values
		 * @name CoreValuesControllerGenerateCoreValueAnalysisStream
		 * @request GET:/corevalues/generate/analysis
		 * @secure
		 */
		coreValuesControllerGenerateCoreValueAnalysisStream: (
			query: {
				type: "friendcheck" | "reflection";
			},
			params: RequestParams = {},
		) =>
			this.request<CoreValuesAnalysis[], any>({
				path: `/corevalues/generate/analysis`,
				method: "GET",
				query: query,
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Core Values
		 * @name CoreValuesControllerGenerateCoreValueSummaryStream
		 * @request GET:/corevalues/generate/summary
		 * @secure
		 */
		coreValuesControllerGenerateCoreValueSummaryStream: (
			query: {
				type: "friendcheck" | "corevalues";
			},
			params: RequestParams = {},
		) =>
			this.request<string[], any>({
				path: `/corevalues/generate/summary`,
				method: "GET",
				query: query,
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Core Values
		 * @name CoreValuesControllerGetFriendCheckCoreValueAnalysis
		 * @request GET:/corevalues/analysis
		 * @secure
		 */
		coreValuesControllerGetFriendCheckCoreValueAnalysis: (
			query: {
				type: "friendcheck" | "reflection";
			},
			params: RequestParams = {},
		) =>
			this.request<CoreValuesAnalysis[], any>({
				path: `/corevalues/analysis`,
				method: "GET",
				query: query,
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Core Values
		 * @name CoreValuesControllerDeleteAnalysis
		 * @request DELETE:/corevalues/analysis
		 * @secure
		 */
		coreValuesControllerDeleteAnalysis: (params: RequestParams = {}) =>
			this.request<string, any>({
				path: `/corevalues/analysis`,
				method: "DELETE",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Core Values
		 * @name CoreValuesControllerGetReflectionSummary
		 * @request GET:/corevalues/summary
		 * @secure
		 */
		coreValuesControllerGetReflectionSummary: (
			query: {
				type: "friendcheck" | "corevalues";
			},
			params: RequestParams = {},
		) =>
			this.request<string, any>({
				path: `/corevalues/summary`,
				method: "GET",
				query: query,
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Core Values
		 * @name CoreValuesControllerDeleteSummary
		 * @request DELETE:/corevalues/summary
		 * @secure
		 */
		coreValuesControllerDeleteSummary: (params: RequestParams = {}) =>
			this.request<string, any>({
				path: `/corevalues/summary`,
				method: "DELETE",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Core Values
		 * @name CoreValuesControllerGetAllCoreValues
		 * @request GET:/corevalues
		 * @secure
		 */
		coreValuesControllerGetAllCoreValues: (params: RequestParams = {}) =>
			this.request<CoreValueItem[], any>({
				path: `/corevalues`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Selected Core Value
		 * @name SelectedCoreValuesControllerGetAll
		 * @request GET:/corevalues/selected
		 * @secure
		 */
		selectedCoreValuesControllerGetAll: (params: RequestParams = {}) =>
			this.request<SelectedCoreValueDto[], any>({
				path: `/corevalues/selected`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Selected Core Value
		 * @name SelectedCoreValuesControllerCreate
		 * @request POST:/corevalues/selected
		 * @secure
		 */
		selectedCoreValuesControllerCreate: (
			data: SelectedCoreValueInputDto[],
			params: RequestParams = {},
		) =>
			this.request<SelectedCoreValueDto[], any>({
				path: `/corevalues/selected`,
				method: "POST",
				body: data,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Core Values
		 * @name ChatCoreValuesControllerRefine
		 * @request POST:/corevalues/chat
		 * @secure
		 */
		chatCoreValuesControllerRefine: (data: RefineCoreValueDto, params: RequestParams = {}) =>
			this.request<CoreValueItem[], any>({
				path: `/corevalues/chat`,
				method: "POST",
				body: data,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Core Values
		 * @name ChatCoreValuesControllerAcceptProposal
		 * @request POST:/corevalues/chat/accept/{coreValueProposalId}
		 * @secure
		 */
		chatCoreValuesControllerAcceptProposal: (
			coreValueProposalId: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/corevalues/chat/accept/${coreValueProposalId}`,
				method: "POST",
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Core Values
		 * @name ChatCoreValuesControllerDeclineProposal
		 * @request POST:/corevalues/chat/decline/{coreValueProposalId}
		 * @secure
		 */
		chatCoreValuesControllerDeclineProposal: (
			coreValueProposalId: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/corevalues/chat/decline/${coreValueProposalId}`,
				method: "POST",
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Core Values
		 * @name ChosenCoreValuesControllerSaveTopCoreValues
		 * @request POST:/corevalues/chosen/save
		 * @secure
		 */
		chosenCoreValuesControllerSaveTopCoreValues: (
			data: Top5CoreValuesDto,
			params: RequestParams = {},
		) =>
			this.request<string[], any>({
				path: `/corevalues/chosen/save`,
				method: "POST",
				body: data,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Core Values
		 * @name ChosenCoreValuesControllerGetAll
		 * @request GET:/corevalues/chosen
		 * @secure
		 */
		chosenCoreValuesControllerGetAll: (params: RequestParams = {}) =>
			this.request<ChosenCoreValueItem[], any>({
				path: `/corevalues/chosen`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Core Values
		 * @name ChosenCoreValuesControllerGetById
		 * @request GET:/corevalues/chosen/{chosenCoreValueId}
		 * @secure
		 */
		chosenCoreValuesControllerGetById: (chosenCoreValueId: string, params: RequestParams = {}) =>
			this.request<ChosenCoreValueItemDetail, any>({
				path: `/corevalues/chosen/${chosenCoreValueId}`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Core Values
		 * @name ChosenCoreValuesControllerGetSources
		 * @request GET:/corevalues/chosen/sources/{chosenCoreValueId}
		 * @secure
		 */
		chosenCoreValuesControllerGetSources: (chosenCoreValueId: string, params: RequestParams = {}) =>
			this.request<ChosenCoreValueSourcesDto, any>({
				path: `/corevalues/chosen/sources/${chosenCoreValueId}`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Core Values
		 * @name ChosenCoreValuesControllerGenerateShareCode
		 * @request POST:/corevalues/chosen/share-code
		 * @secure
		 */
		chosenCoreValuesControllerGenerateShareCode: (params: RequestParams = {}) =>
			this.request<ShareCodeResponseDto, any>({
				path: `/corevalues/chosen/share-code`,
				method: "POST",
				secure: true,
				format: "json",
				...params,
			}),
	};
	reflection = {
		/**
		 * No description
		 *
		 * @tags Reflection
		 * @name ReflectionControllerGetReflection
		 * @request GET:/reflection
		 * @secure
		 */
		reflectionControllerGetReflection: (params: RequestParams = {}) =>
			this.request<ReflectionSummary[], any>({
				path: `/reflection`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Reflection
		 * @name ReflectionControllerGetReflectionById
		 * @request GET:/reflection/{reflectionId}
		 * @secure
		 */
		reflectionControllerGetReflectionById: (reflectionId: string, params: RequestParams = {}) =>
			this.request<ReflectionChat, any>({
				path: `/reflection/${reflectionId}`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Reflection
		 * @name ReflectionControllerAnswerInitialQuestion
		 * @request POST:/reflection/{chatId}/respond/initial
		 * @secure
		 */
		reflectionControllerAnswerInitialQuestion: (
			chatId: string,
			data: ReflectionInitialResponseDto,
			params: RequestParams = {},
		) =>
			this.request<ReflectionChat, any>({
				path: `/reflection/${chatId}/respond/initial`,
				method: "POST",
				body: data,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Reflection
		 * @name ReflectionControllerAnswerQuestion
		 * @request POST:/reflection/{chatId}/respond/text
		 * @secure
		 */
		reflectionControllerAnswerQuestion: (
			chatId: string,
			data: ReflectionTextResponseDto,
			params: RequestParams = {},
		) =>
			this.request<ReflectionChat, any>({
				path: `/reflection/${chatId}/respond/text`,
				method: "POST",
				body: data,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Reflection
		 * @name ReflectionControllerGenerateReflection
		 * @request POST:/reflection/{chatId}/generate
		 * @secure
		 */
		reflectionControllerGenerateReflection: (chatId: string, params: RequestParams = {}) =>
			this.request<ReflectionChat, any>({
				path: `/reflection/${chatId}/generate`,
				method: "POST",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Reflection
		 * @name ReflectionControllerGenerateCoreValues
		 * @request POST:/reflection/{chatId}/generate/corevalues
		 * @secure
		 */
		reflectionControllerGenerateCoreValues: (chatId: string, params: RequestParams = {}) =>
			this.request<GenerateSelectedCoreValuesDto, any>({
				path: `/reflection/${chatId}/generate/corevalues`,
				method: "POST",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Reflection
		 * @name ReflectionControllerSkipReflection
		 * @request POST:/reflection/{chatId}/skip
		 * @secure
		 */
		reflectionControllerSkipReflection: (chatId: string, params: RequestParams = {}) =>
			this.request<ReflectionChat, any>({
				path: `/reflection/${chatId}/skip`,
				method: "POST",
				secure: true,
				format: "json",
				...params,
			}),
	};
	perfectDay = {
		/**
		 * No description
		 *
		 * @tags PerfectDay
		 * @name PerfectDayControllerInitializeSceneWithChat
		 * @request POST:/perfect-day/initialize
		 * @secure
		 */
		perfectDayControllerInitializeSceneWithChat: (params: RequestParams = {}) =>
			this.request<PerfectDayScene, any>({
				path: `/perfect-day/initialize`,
				method: "POST",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PerfectDay
		 * @name PerfectDayControllerCreateScene
		 * @request POST:/perfect-day/create-scene
		 * @secure
		 */
		perfectDayControllerCreateScene: (data?: CreatePerfectDayScene, params: RequestParams = {}) =>
			this.request<PerfectDayScene, any>({
				path: `/perfect-day/create-scene`,
				method: "POST",
				body: data,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PerfectDay
		 * @name PerfectDayControllerSendUserMessageInChat
		 * @request POST:/perfect-day/{chatId}/respond/text
		 * @secure
		 */
		perfectDayControllerSendUserMessageInChat: (
			chatId: string,
			data: PerfectdayTextResponseDto,
			params: RequestParams = {},
		) =>
			this.request<PerfectDayChat, any>({
				path: `/perfect-day/${chatId}/respond/text`,
				method: "POST",
				body: data,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PerfectDay
		 * @name PerfectDayControllerGenerateChatResponse
		 * @request POST:/perfect-day/{chatId}/generate-response
		 * @secure
		 */
		perfectDayControllerGenerateChatResponse: (chatId: string, params: RequestParams = {}) =>
			this.request<PerfectDayChat, any>({
				path: `/perfect-day/${chatId}/generate-response`,
				method: "POST",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PerfectDay
		 * @name PerfectDayControllerGetScenesByUser
		 * @request GET:/perfect-day/scenes
		 * @secure
		 */
		perfectDayControllerGetScenesByUser: (
			query?: {
				chatStatus?: "REFLECTION" | "IMAGE_GENERATION" | "COMPLETED";
			},
			params: RequestParams = {},
		) =>
			this.request<PerfectDayScene[], any>({
				path: `/perfect-day/scenes`,
				method: "GET",
				query: query,
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PerfectDay
		 * @name PerfectDayControllerGetSceneWithChat
		 * @request GET:/perfect-day/scene-with-chat/{sceneId}
		 * @secure
		 */
		perfectDayControllerGetSceneWithChat: (sceneId: string, params: RequestParams = {}) =>
			this.request<PerfectDayScene, any>({
				path: `/perfect-day/scene-with-chat/${sceneId}`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PerfectDay
		 * @name PerfectDayControllerUpdateSceneOrder
		 * @request POST:/perfect-day/update-scene-order
		 * @secure
		 */
		perfectDayControllerUpdateSceneOrder: (
			data: UpdatePerfectDaySceneOrder,
			params: RequestParams = {},
		) =>
			this.request<PerfectDayScene[], any>({
				path: `/perfect-day/update-scene-order`,
				method: "POST",
				body: data,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PerfectDay
		 * @name PerfectDayControllerUpdateScene
		 * @request PUT:/perfect-day/{sceneId}
		 * @secure
		 */
		perfectDayControllerUpdateScene: (
			sceneId: string,
			data: UpdatePerfectDayScene,
			params: RequestParams = {},
		) =>
			this.request<PerfectDayScene, any>({
				path: `/perfect-day/${sceneId}`,
				method: "PUT",
				body: data,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PerfectDay
		 * @name PerfectDayControllerDeleteScene
		 * @request DELETE:/perfect-day/{sceneId}
		 * @secure
		 */
		perfectDayControllerDeleteScene: (sceneId: string, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/perfect-day/${sceneId}`,
				method: "DELETE",
				secure: true,
				...params,
			}),
	};
	friendcheck = {
		/**
		 * No description
		 *
		 * @tags Friendcheck
		 * @name FriendcheckControllerGetFriendHash
		 * @request GET:/friendcheck/hash
		 * @secure
		 */
		friendcheckControllerGetFriendHash: (params: RequestParams = {}) =>
			this.request<string, any>({
				path: `/friendcheck/hash`,
				method: "GET",
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Friendcheck
		 * @name FriendcheckControllerGetAllSubmissions
		 * @request GET:/friendcheck/submissions
		 * @secure
		 */
		friendcheckControllerGetAllSubmissions: (params: RequestParams = {}) =>
			this.request<FriendCheckSubmission[], any>({
				path: `/friendcheck/submissions`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Friendcheck
		 * @name FriendcheckControllerDeleteAnswerForLatestVersion
		 * @request DELETE:/friendcheck/submissions
		 * @secure
		 */
		friendcheckControllerDeleteAnswerForLatestVersion: (params: RequestParams = {}) =>
			this.request<string, any>({
				path: `/friendcheck/submissions`,
				method: "DELETE",
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Friendcheck
		 * @name FriendcheckControllerGetSubmission
		 * @request GET:/friendcheck/submissions/{friendCheckSubmissionId}
		 * @secure
		 */
		friendcheckControllerGetSubmission: (
			friendCheckSubmissionId: string,
			params: RequestParams = {},
		) =>
			this.request<FriendCheckSubmission, any>({
				path: `/friendcheck/submissions/${friendCheckSubmissionId}`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Friendcheck
		 * @name FriendcheckControllerDeleteSubmission
		 * @request DELETE:/friendcheck/submissions/{friendCheckSubmissionId}
		 * @secure
		 */
		friendcheckControllerDeleteSubmission: (
			friendCheckSubmissionId: string,
			params: RequestParams = {},
		) =>
			this.request<string, any>({
				path: `/friendcheck/submissions/${friendCheckSubmissionId}`,
				method: "DELETE",
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Friendcheck
		 * @name FriendcheckControllerGetMyFriendCheck
		 * @request GET:/friendcheck/my-friendcheck
		 * @secure
		 */
		friendcheckControllerGetMyFriendCheck: (params: RequestParams = {}) =>
			this.request<FriendCheck, any>({
				path: `/friendcheck/my-friendcheck`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Friendcheck
		 * @name FriendcheckControllerGetPublicFriendCheck
		 * @request GET:/friendcheck/public/{friendId}/{friendHash}
		 * @secure
		 */
		friendcheckControllerGetPublicFriendCheck: (
			friendId: string,
			friendHash: string,
			params: RequestParams = {},
		) =>
			this.request<FriendCheck, any>({
				path: `/friendcheck/public/${friendId}/${friendHash}`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Friendcheck
		 * @name FriendcheckControllerPostPublicFriendCheck
		 * @request POST:/friendcheck/public/{friendId}/{friendHash}
		 * @secure
		 */
		friendcheckControllerPostPublicFriendCheck: (
			friendId: string,
			friendHash: string,
			data: SubmitFriendcheckDto,
			params: RequestParams = {},
		) =>
			this.request<FriendCheckSubmissionResponse, any>({
				path: `/friendcheck/public/${friendId}/${friendHash}`,
				method: "POST",
				body: data,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Friendcheck
		 * @name FriendcheckControllerPatchPublicFriendCheckWithEmail
		 * @request PATCH:/friendcheck/public/{friendId}/{friendHash}
		 * @secure
		 */
		friendcheckControllerPatchPublicFriendCheckWithEmail: (
			friendId: string,
			friendHash: string,
			data: PatchFriendCheckEmailDto,
			params: RequestParams = {},
		) =>
			this.request<string, any>({
				path: `/friendcheck/public/${friendId}/${friendHash}`,
				method: "PATCH",
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Friendcheck
		 * @name FriendcheckControllerGetFriendCheckEnabled
		 * @request GET:/friendcheck/enabled
		 * @secure
		 */
		friendcheckControllerGetFriendCheckEnabled: (params: RequestParams = {}) =>
			this.request<boolean, any>({
				path: `/friendcheck/enabled`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Friendcheck
		 * @name FriendcheckControllerUpdateFriendCheckEnabled
		 * @request PATCH:/friendcheck/enabled
		 * @secure
		 */
		friendcheckControllerUpdateFriendCheckEnabled: (
			data: PatchFriendCheckEnabledDto,
			params: RequestParams = {},
		) =>
			this.request<string, any>({
				path: `/friendcheck/enabled`,
				method: "PATCH",
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Friendcheck
		 * @name FriendcheckControllerMarkFriendCheckSeen
		 * @request PATCH:/friendcheck/seen
		 * @secure
		 */
		friendcheckControllerMarkFriendCheckSeen: (
			data: PatchFriendCheckSeenDto,
			params: RequestParams = {},
		) =>
			this.request<string, any>({
				path: `/friendcheck/seen`,
				method: "PATCH",
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Friendcheck
		 * @name FriendcheckControllerDeleteAnalysis
		 * @request DELETE:/friendcheck/analysis
		 * @secure
		 */
		friendcheckControllerDeleteAnalysis: (params: RequestParams = {}) =>
			this.request<string, any>({
				path: `/friendcheck/analysis`,
				method: "DELETE",
				secure: true,
				...params,
			}),
	};
	public = {
		/**
		 * No description
		 *
		 * @tags Public
		 * @name PublicControllerGetChosenCoreValuesByShareCode
		 * @request GET:/public/corevalues/chosen
		 */
		publicControllerGetChosenCoreValuesByShareCode: (
			query: {
				shareCode: string;
			},
			params: RequestParams = {},
		) =>
			this.request<ChosenCoreValueItem[], any>({
				path: `/public/corevalues/chosen`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),
	};
	models = {
		/**
		 * No description
		 *
		 * @tags Models
		 * @name ModelsControllerGetAllModels
		 * @request GET:/models
		 */
		modelsControllerGetAllModels: (params: RequestParams = {}) =>
			this.request<ModelDto[], any>({
				path: `/models`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Models
		 * @name ModelsControllerGetDefaultModel
		 * @request GET:/models/default
		 */
		modelsControllerGetDefaultModel: (params: RequestParams = {}) =>
			this.request<ModelDto, any>({
				path: `/models/default`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	onboarding = {
		/**
		 * No description
		 *
		 * @tags Onboarding
		 * @name OnboardingControllerUploadImage
		 * @request POST:/onboarding/upload
		 */
		onboardingControllerUploadImage: (params: RequestParams = {}) =>
			this.request<string, any>({
				path: `/onboarding/upload`,
				method: "POST",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Onboarding
		 * @name OnboardingControllerInvite
		 * @request POST:/onboarding/invite
		 */
		onboardingControllerInvite: (data: SendInviteEmailDto, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/onboarding/invite`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),
	};
	manifest = {
		/**
		 * No description
		 *
		 * @tags Manifest
		 * @name ManifestControllerShare
		 * @request POST:/manifest/share
		 * @secure
		 */
		manifestControllerShare: (data: ShareManifestDto, params: RequestParams = {}) =>
			this.request<object, any>({
				path: `/manifest/share`,
				method: "POST",
				body: data,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	personalMission = {
		/**
		 * No description
		 *
		 * @tags Personal Mission
		 * @name PersonalMissionControllerCreate
		 * @request POST:/personal-mission
		 * @secure
		 */
		personalMissionControllerCreate: (params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/personal-mission`,
				method: "POST",
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Personal Mission
		 * @name PersonalMissionControllerGet
		 * @request GET:/personal-mission
		 * @secure
		 */
		personalMissionControllerGet: (params: RequestParams = {}) =>
			this.request<PersonalMissionResponseDto, any>({
				path: `/personal-mission`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Personal Mission
		 * @name PersonalMissionControllerRefine
		 * @request POST:/personal-mission/refine
		 * @secure
		 */
		personalMissionControllerRefine: (data: RefinePersonalMissionDto, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/personal-mission/refine`,
				method: "POST",
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Personal Mission
		 * @name PersonalMissionControllerAcceptRefineProposal
		 * @request POST:/personal-mission/refine/proposal/{missionProposalId}/accept
		 * @secure
		 */
		personalMissionControllerAcceptRefineProposal: (
			missionProposalId: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/personal-mission/refine/proposal/${missionProposalId}/accept`,
				method: "POST",
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Personal Mission
		 * @name PersonalMissionControllerDeclineRefineProposal
		 * @request POST:/personal-mission/refine/proposal/{missionProposalId}/decline
		 * @secure
		 */
		personalMissionControllerDeclineRefineProposal: (
			missionProposalId: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/personal-mission/refine/proposal/${missionProposalId}/decline`,
				method: "POST",
				secure: true,
				...params,
			}),
	};
}
